import React from 'react';
import Selection from "@molecules/selection/selection";
import {FilterDispatcherContext} from "@providers/filters";
import {UpdateRangeSelectionOptions} from "@hooks/selection.options";

function PriceSelection(props) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const {show, options, selected_range} = props.items;
    const selectedRangeCopy = JSON.parse(JSON.stringify(selected_range));

    function handleChange(data) {
        if (JSON.stringify(data) !== JSON.stringify(selectedRangeCopy)) {
            const new_option = UpdateRangeSelectionOptions(options, data);
            filterDispatcher({
                type: 'PRICES_OPTIONS',
                payload: new_option
            });
        }
    }

    const {showRangeInputInCaption} = props;
    return (
        <div className={(show ? 'd-block' : 'd-none') + ' ' + (typeof props.className !== "undefined" ? props.className : '')}>
            {
                (typeof showRangeInputInCaption !== "undefined" && showRangeInputInCaption) ?
                    <label className="range-title">
                        قیمت
                        <span className="range-unit"> (تومان)</span>
                    </label>
                    : ''
            }
            <Selection
                type="range"
                showRangeInputInCaption={!!showRangeInputInCaption}
                name={props.name !== undefined ? props.name : 'price'}
                options={options}
                selected_range={selected_range}
                label="قیمت"
                unit="money"
                onChange={(data) => handleChange(data)}
                showLabelAndSelected={!!(props.showLabelAndSelected)}
            />
        </div>
    )
}

export default PriceSelection;
